import React from "react";
import NotificationsPage from "@pages/Notifications/NotificationsPage";
import ProtectedRoute from "@components/routes/ProtectedRoute";

export default [
    {
        path: "notifications",
        element: <ProtectedRoute allowedRoles={["root_admin"]} />,
        children: [
            {
                path: "",
                element: <NotificationsPage />,
            },
        ],
    },
];
